import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import request from '../api';
import { selectRole } from '../RoleSelector/roleselector';
import { selectRoleMobile } from '../RoleSelectorMobile/roleselectormobile';
import { bindArea } from '../AreaBind/areabind';
import { miloAlert } from '../AlertDialog';
import { _$ } from '../util/domHelper';
import dialogTpl from './tpl';
import { appendHtml, findNodeByClass } from '../util/domHelper';
import { MyGiftList as getMyGiftList } from '@tencent/milo-core';
import tplGiftList from "./tplGiftList";
import './style.css';

var tableBodyRender = function tableBodyRender(list) {
  var getStatus = function getStatus(giftInfo) {
    if (giftInfo.iStatus == '0') {
      return '成功';
    }

    if (!giftInfo.itemList) {
      return '发货中';
    } else {
      return giftInfo.itemList.map(function (item) {
        if (item.iItemStatus == '0') {
          return "<span style=\"color:green;\">".concat(item.sItemName, "(").concat(item.iItemNum, ") \u5DF2\u53D1\u8D27 </span><br>");
        } else {
          return "<span style=\"color:#aaa;\">".concat(item.sItemName, "(").concat(item.iItemNum, ") \u53D1\u8D27\u4E2D </span><br> ");
        }
      }).join('');
    }
  };

  if (list && list.length) {
    return list.map(function (giftInfo) {
      return "\n          <tr>\n              <td>".concat(giftInfo.getTime, "</td>\n              <td>").concat(giftInfo.areaName, "</td>\n              <td>").concat(giftInfo.packageName, "</td>\n              <td>").concat(giftInfo.iPackageNum, "</td>\n              <td>").concat(getStatus(giftInfo), "</td>\n          </tr>\n      ");
    }).join('');
  } else {
    return "\n    <tr>\n        <td colspan=\"4\" align=\"center\">\u60A8\u5C1A\u672A\u83B7\u5F97\u4EFB\u4F55\u793C\u5305</td>\n    </tr>\n  ";
  }
};

var tableFooterRender = function tableFooterRender(_ref, iFlowId) {
  var pageNow = _ref.pageNow,
      pageTotal = _ref.pageTotal;

  if (pageTotal > 1) {
    var prevClass, nextClass;

    if (pageNow == pageTotal) {
      nextClass = 'display: none';
    }

    if (pageNow == 1) {
      prevClass = 'display: none';
    }

    return "\n          <tr>\n              <td class=\"page\" colspan=\"4\">\n                  <a class=\"pageBtn\" id=\"myGiftlist_prevPageBtn_".concat(iFlowId, "\" title=\"\u4E0A\u4E00\u9875\" style='").concat(prevClass, "'>\u4E0A\u4E00\u9875</a>\n                  <span class=\"page_num\"><em class=\"now_page\" >").concat(pageNow, "</em class=\"total_page\" >/<em>").concat(pageTotal, "</em></span>\n                  <a class=\"pageBtn\" id=\"myGiftlist_nextPageBtn_").concat(iFlowId, "\" title=\"\u4E0B\u4E00\u9875\" style='").concat(nextClass, "'>\u4E0B\u4E00\u9875</a>\n              </td>\n          </tr>\n      ");
  }

  return '';
};

var MyGiftListComp = /*#__PURE__*/function () {
  function MyGiftListComp(option) {
    _classCallCheck(this, MyGiftListComp);

    this.option = _objectSpread({
      plat: 'pc',
      iActivityId: '',
      iFlowId: '',
      flowConfig: {
        pageSize: 10,
        pageNow: 1
      },
      extendRole: {},
      onSuccess: null,
      onFail: null,
      contentId: "myGiftlist_dialog_".concat(option.iFlowId),
      closeBtnId: "myGiftlist_dialog_close_".concat(option.iFlowId),
      tBodyContentId: "myGiftlist_tbody_".concat(option.iFlowId),
      tFooterContentId: "myGiftlist_footer_".concat(option.iFlowId),
      prevPageBtnId: "myGiftlist_prevPageBtn_".concat(option.iFlowId),
      nextPageBtnId: "myGiftlist_nextPageBtn_".concat(option.iFlowId),
      tableBodyRender: null,
      tableFooterRender: null,
      pageCount: 1
    }, option);
    this.dialog = null;
  }

  _createClass(MyGiftListComp, [{
    key: "getList",
    value: function getList() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var success = arguments.length > 1 ? arguments[1] : undefined;
      var fail = arguments.length > 2 ? arguments[2] : undefined;
      var self = this;
      var onSuccess = success || self.option.onSuccess;
      var onFail = fail || this.option.onFail;
      return new Promise(function (resolve, reject) {
        request(getMyGiftList, self.option, page).then(function (giftListInfo) {
          _this.pageTotal = giftListInfo.pageTotal || 0;
          _this.giftListInfo = giftListInfo;

          if (onSuccess) {
            onSuccess(giftListInfo);
          } else {
            console.log('获取列表', giftListInfo);
          }

          resolve(giftListInfo);
        })["catch"](function (err) {
          var errCode = err.errCode,
              areaBindOption = err.areaBindOption,
              rsOption = err.rsOption;

          if (errCode === 2) {
            // 先绑定大区
            bindArea({
              bindOptions: _objectSpread(_objectSpread({}, areaBindOption), {}, {
                flowConfig: _objectSpread({}, self.option.extendRole),
                onSuccess: function onSuccess() {
                  resolve(self.getList(page));
                },
                type: 'commit'
              })
            });
          } else if (errCode === 3) {
            // 先选择角色
            var selectRoleFn = self.option.plat === 'mobile' ? selectRoleMobile : selectRole;
            selectRoleFn(_objectSpread(_objectSpread(_objectSpread({}, rsOption), self.option.extendRole), {}, {
              onSubmit: function onSubmit(role) {
                var sData = self.option.flowConfig.sData || {};
                sData = _objectSpread(_objectSpread({}, sData), {}, {
                  sServiceType: err.rsOption.gameId,
                  sArea: role.area,
                  sPartition: role.partition,
                  sRoleId: role.roleId,
                  sAreaName: role.areaName,
                  sRoleName: role.roleName,
                  md5str: role.md5str,
                  iSex: role.roleSex || '',
                  sPlatId: role.platid,
                  ams_checkparam: role.checkparam,
                  checkparam: role.checkparam
                });
                self.option.flowConfig.sData = sData;
                resolve(self.getList(page));
              }
            }));
          } else {
            reject(err);

            if (errCode == -1) {
              return;
            }

            if (onFail) {
              onFail(err);
            } else {
              miloAlert(err.errMsg || err.msg || err.sMsg || '网络繁忙，请稍后重试');
            }
          }
        });
      });
    }
  }, {
    key: "showDialog",
    value: function showDialog() {
      var _this2 = this;

      this.getList().then(function (res) {
        var iRet = res.iRet,
            sMsg = res.sMsg;

        if (iRet !== '0') {
          if (onFail) {
            onFail(sMsg);
          } else {
            miloAlert(sMsg || '网络繁忙，请稍后重试');
          }

          return;
        }

        _this2.onRender(res);
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, {
    key: "onRender",
    value: function onRender(res) {
      var _this3 = this;

      var _this$option = this.option,
          contentId = _this$option.contentId,
          closeBtnId = _this$option.closeBtnId,
          iFlowId = _this$option.iFlowId;

      if (!_$(contentId)) {
        var html = tplGiftList(iFlowId);
        appendHtml(document.body, html, "myGiftListContent_".concat(iFlowId));
      }

      this.dialog = _$(contentId);
      this.dialog.style.display = 'block';

      var closeBtn = _$(closeBtnId);

      if (closeBtn) closeBtn.onclick = function () {
        _this3.dialog.style.display = 'none';
      };
      this.onRenderTable(res);
    }
  }, {
    key: "onRenderTable",
    value: function onRenderTable(data) {
      var pageNow = data.pageNow,
          pageTotal = data.pageTotal,
          myGiftList = data.myGiftList;
      this.pageCount = pageNow;
      this.onRenderTableBody(myGiftList);
      this.onRenderFooter({
        pageNow: pageNow,
        pageTotal: pageTotal
      });
    }
  }, {
    key: "onRenderTableBody",
    value: function onRenderTableBody(list) {
      var _this$option2 = this.option,
          tBodyContentId = _this$option2.tBodyContentId,
          iFlowId = _this$option2.iFlowId,
          optionTableBodyRender = _this$option2.tableBodyRender;
      var tableBodyRenderFunc = optionTableBodyRender ? optionTableBodyRender : tableBodyRender;
      var myGiftList = tableBodyRenderFunc(list, iFlowId);
      if (_$(tBodyContentId)) _$(tBodyContentId).innerHTML = myGiftList;
    }
  }, {
    key: "onRenderFooter",
    value: function onRenderFooter(data) {
      var _this4 = this;

      var _this$option3 = this.option,
          iFlowId = _this$option3.iFlowId,
          tFooterContentId = _this$option3.tFooterContentId,
          prevPageBtnId = _this$option3.prevPageBtnId,
          nextPageBtnId = _this$option3.nextPageBtnId,
          optionTableFooterRender = _this$option3.tableFooterRender;
      var tableFooterRenderFunc = optionTableFooterRender ? optionTableFooterRender : tableFooterRender;
      var myGiftFooter = tableFooterRenderFunc(data, iFlowId);

      var footer = _$(tFooterContentId);

      if (footer) footer.innerHTML = myGiftFooter;

      var prevBtn = _$(prevPageBtnId);

      var nextBtn = _$(nextPageBtnId);

      if (prevBtn) prevBtn.onclick = function () {
        _this4.onPageChange(parseInt(_this4.pageCount) - 1);
      };
      if (nextBtn) nextBtn.onclick = function () {
        _this4.onPageChange(parseInt(_this4.pageCount) + 1);
      };
    }
  }, {
    key: "onPageChange",
    value: function onPageChange(pageCount) {
      var _this5 = this;

      this.getList(pageCount).then(function (res) {
        _this5.onRenderTable(res);
      });
    }
  }, {
    key: "renderDialog",
    value: function renderDialog(tplHtml, id) {
      var dialogTplHtml = dialogTpl(tplHtml);

      if (!this.dialog) {
        this.dialog = appendHtml(document.body, dialogTplHtml, id);
      } else {
        var contentEl = findNodeByClass(this.dialog, 'milo-dialog-content')[0];
        contentEl.innerHTML = tplHtml;
      }

      return this.dialog;
    }
  }, {
    key: "cloasDialog",
    value: function cloasDialog() {
      if (this.dialog) {
        this.dialog.style.display = 'none';
        this.dialog.parentNode.removeChild(this.dialog);
      }
    }
  }]);

  return MyGiftListComp;
}();

export { MyGiftListComp as default };
export var MyGiftList = {
  init: function init(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new MyGiftListComp(option);
        resolve(instance);
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: '个人获奖列表模块初始化失败'
        });
      }
    });
  }
};